import type { ICacheService } from './types';

let instancePromise: Promise<ICacheService> | null = null;

export const getCacheService = (): Promise<ICacheService> => {
  if (!instancePromise) {
    instancePromise = (async () => {
      if (typeof window === 'undefined') {
        const mod = await import('./service');
        return mod.default;
      } else {
        const mod = await import('./mock');
        return mod.default;
      }
    })();
  }

  return instancePromise;
};
